import React from 'react';
import ListingCard, { ListingCardListing } from '../../ListingCard';
import { SellListing } from '../../../hooks/useSellListings';

type ListingPickerListProps = {
  listings: SellListing[];
  onSelect: (listing: SellListing) => void;
};

/** Format "Street 12" / "City" lines from a raw listing address. */
export function formatListingAddress(listing: SellListing): {
  line1: string;
  line2: string;
} {
  const a = listing.address || {};
  const line1 = [a.street, a.houseNumber].filter(Boolean).join(' ');
  return { line1: line1 || '—', line2: a.city || '' };
}

/**
 * Sell-listing picker for the Tools flows, rendered with the app's small
 * ListingCard (same card family as My Listings) so fonts/spacing/photos match
 * the rest of the app. Tapping a card selects it.
 */
const ListingPickerList: React.FC<ListingPickerListProps> = ({ listings, onSelect }) => (
  <div className="tool-flow__list">
    {listings.map((listing) => (
      <ListingCard
        key={listing._id}
        size="small"
        type="seller"
        listing={{ ...listing, isUserOwnEvent: true } as unknown as ListingCardListing}
        onOpen={() => onSelect(listing)}
        isLoggedIn
      />
    ))}
  </div>
);

export default ListingPickerList;
